import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BOOKS } from "../data/content";
import { BookCard } from "./BookCard";
import { Reveal, SectionHeading } from "./Reveal";

export const FeaturedBooksPreview = () => {
  const featured = BOOKS.slice(0, 3);
  return (
    <section
      id="books"
      data-testid="featured-books-section"
      className="relative py-24 lg:py-36 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="DatAsia Editions · The Bookshelf"
            title={
              <>
                Masterworks of Khmer
                <br />
                history &amp; literature
              </>
            }
          />
          <Reveal delay={0.1}>
            <Link
              to="/books"
              data-testid="view-all-books-link"
              className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--text)] gold-underline pb-1"
            >
              View all {BOOKS.length} books
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-14">
          {featured.map((book, i) => (
            <Reveal key={book.id} delay={i * 0.08}>
              <BookCard book={book} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
